(() => {
  if (window.ovrzeStudioReady) return;
  window.ovrzeStudioReady = true;
  document.addEventListener('click', event => {
    const element=event.target instanceof Element ? event.target : null;
    if (!element) return;
    const filter=element.closest('[data-studio-filter]');
    if (filter) {
      const section=filter.closest('.os-collection');
      section.querySelectorAll('[data-studio-filter]').forEach(button=>button.setAttribute('aria-pressed',String(button===filter)));
      section.querySelectorAll('[data-studio-kind]').forEach(item=>{item.hidden=filter.dataset.studioFilter!=='all'&&item.dataset.studioKind!==filter.dataset.studioFilter;});
    }
    const menuLink=element.closest('.os-menu nav a');
    if (menuLink) menuLink.closest('details').open=false;
  });
  document.addEventListener('keydown', event => {
    if(event.key!=='Escape') return;
    const menu=document.querySelector('.os-menu[open]');
    if(menu){menu.open=false;menu.querySelector('summary').focus();}
  });

  function initializeBundles(scope=document) {
    scope.querySelectorAll('[data-studio-bundle]').forEach(bundle => {
      if (bundle.dataset.bundleReady) return;
      bundle.dataset.bundleReady = 'true';
      const native = bundle.querySelector('[data-bundle-variant]');
      const fields = [...bundle.querySelectorAll('[data-bundle-option]')];
      const button = bundle.querySelector('[data-bundle-submit]');
      const status = bundle.querySelector('.ow-form-status');
      const formatter = new Intl.NumberFormat(bundle.dataset.bundleLocale || 'de', {style:'currency',currency:bundle.dataset.bundleCurrency || 'EUR'});
      bundle.querySelector('[data-bundle-native-field]').hidden = true;
      bundle.querySelectorAll('[data-bundle-size-field]').forEach(field => {field.hidden=false;});
      fields.forEach(field => {field.disabled=false;});
      function syncBundle() {
        const zipper = fields.find(field => field.dataset.bundleOption === '0').value;
        const pants = fields.find(field => field.dataset.bundleOption === '1').value;
        const variant = [...native.options].find(option => option.value && option.dataset.zipper === zipper && option.dataset.pants === pants);
        native.value = variant?.value || '';
        button.disabled = !variant || variant.disabled;
        status.textContent = !zipper || !pants ? bundle.dataset.bundleMissing : button.disabled ? bundle.dataset.bundleUnavailable : '';
        if (!variant) return;
        const price = Number(variant.dataset.price);
        const original = Number(bundle.dataset.bundleTotal);
        const saving = Math.max(0, original-price);
        bundle.querySelector('[data-bundle-price]').textContent = formatter.format(price/100);
        const savingText = bundle.querySelector('[data-bundle-saving]');
        if (savingText) savingText.textContent = formatter.format(saving/100);
        const savingLine = bundle.querySelector('.os-bundle-saving');
        if (savingLine) savingLine.hidden = saving <= 0;
        const badge = bundle.querySelector('[data-bundle-badge]');
        if (badge) badge.hidden = saving <= 0;
      }
      fields.forEach(field => field.addEventListener('change',syncBundle));
      syncBundle();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>initializeBundles());
  else initializeBundles();
  document.addEventListener('shopify:section:load',event=>initializeBundles(event.target));
})();
